import { createSlice } from "@reduxjs/toolkit";


// Define the initial state structure
const initialState = {
  brand: {}, // `brand` is an object
  product: {},
  isInviteModalIsOpen: false,
  isTourGuideIsFinished: 0,
  isTaskIsEditable: false,
  isTemplateUpdated: false,
  dodoReturnUrl: process.env.NEXT_PUBLIC_RETURN_URL,
  creditEventCount: 0,
  changedAiMode: "",
};

const Common = createSlice({
  name: "common",
  initialState,
  reducers: {
    // Action to set the brand object
    setBrand: (state, action) => {
      // Immer allows mutating the state directly
      state.brand = { ...action.payload };
    },

    // Toggle the task modal
    toggleInviteModal: (state) => {
      return { ...state, isInviteModalIsOpen: !state.isInviteModalIsOpen };
    },
    // Toggle the cart modal
    toggleShoppingCartModal: (state) => {
      return { ...state, shoppingCartModal: !state.shoppingCartModal };
    },
    // Toggle the task modal
    toggleIsTourGuideFinished: (state, action) => {
      //state.isInviteModalIsOpen = !state.isInviteModalIsOpen;
      return { ...state, isTourGuideIsFinished: action?.payload };
    },
    setProduct: (state, action) => {
      return { ...state, product: action?.payload };
    },
    toggleTaskEdit: (state, action) => {
      return { ...state, isTaskIsEditable: action?.payload };
    },
    templatesUpdated: (state) => {
      return { ...state, isTemplateUpdated: !state?.isTemplateUpdated };
    },

    setDodoReturnUrl: (state, action) => {
      return {...state, dodoReturnUrl: action?.payload};
    },
    updateEventCount: (state) => {
      return {...state, creditEventCount: state.creditEventCount + 1 }
    },
    setChangedAIMode: (state, action) => {
      state.changedAiMode = action.payload;
    }
  },
});

// Exporting the action and reducer
export const {
  setBrand,
  toggleInviteModal,
  toggleIsTourGuideFinished,
  setProduct,
  toggleTaskEdit,
  templatesUpdated,
  toggleShoppingCartModal,
  setDodoReturnUrl,
  updateEventCount,
  setChangedAIMode
} = Common.actions;
export default Common.reducer;
